import { Component, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

export interface ApprovalStepTimelineItem {
  step_label: string;
  order: number;
  approval_id: number;
  version_number: number;
  returned?: boolean;
  step_number?: number;
  approved_at?: string;
  /** Nome do papel (Cedente, Cotista, Prestador de Serviço) – exibir só quando mudar. */
  role_name?: string;
  /** Nome de quem aprovou – exibir em passos que não são Edição. */
  signed_by?: string | null;
  /** True quando o passo é Edição (não mostra "Aprovado por"). */
  is_editing_step?: boolean;
}

@Component({
  selector: 'app-approvation-timeline-steps',
  templateUrl: './approvation-timeline-steps.component.html',
  styleUrls: ['./approvation-timeline-steps.component.scss'],
})
export class ApprovationTimelineStepsComponent implements AfterViewInit {
  @Input() timelineSteps: ApprovalStepTimelineItem[] = [];

  @ViewChild('scrollContainer') scrollContainer: ElementRef<HTMLElement> | undefined;

  /** 4 steps por clique (cada step = 140px) */
  scrollAmount = 560;
  canScrollLeft = false;
  canScrollRight = false;

  ngAfterViewInit(): void {
    // Após renderizar, posicionar o scroll no final (passos mais recentes)
    setTimeout(() => {
      const el = this.scrollContainer?.nativeElement;
      if (el) {
        el.scrollLeft = el.scrollWidth;
      }
      this.updateScrollButtons();
    }, 0);
  }

  scrollLeft(): void {
    if (!this.canScrollLeft) {
      return;
    }
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      el.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
      setTimeout(() => this.updateScrollButtons(), 300);
    }
  }

  scrollRight(): void {
    if (!this.canScrollRight) {
      return;
    }
    const el = this.scrollContainer?.nativeElement;
    if (el) {
      el.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
      setTimeout(() => this.updateScrollButtons(), 300);
    }
  }

  onScroll(): void {
    this.updateScrollButtons();
  }

  private updateScrollButtons(): void {
    const el = this.scrollContainer?.nativeElement;
    if (!el) {
      this.canScrollLeft = false;
      this.canScrollRight = false;
      return;
    }
    this.canScrollLeft = el.scrollLeft > 0;
    this.canScrollRight = el.scrollLeft < el.scrollWidth - el.clientWidth - 2;
  }

  formatDate(isoDate: string | undefined): string {
    if (!isoDate) {
      return '';
    }
    try {
      const d = new Date(isoDate);
      if (Number.isNaN(d.getTime())) {
        return '';
      }
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      const h = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} às ${h}:${min}`;
    } catch {
      return '';
    }
  }

  private getLastIndex(): number {
    return this.timelineSteps.length > 0 ? this.timelineSteps.length - 1 : -1;
  }

  isPastStep(index: number): boolean {
    const lastIndex = this.getLastIndex();
    return lastIndex >= 0 && index < lastIndex;
  }

  isCurrentStep(index: number): boolean {
    const lastIndex = this.getLastIndex();
    return lastIndex >= 0 && index === lastIndex;
  }

  /** Mostra o nome do papel apenas quando muda em relação ao passo anterior. */
  showRoleName(index: number): boolean {
    if (index === 0) return !!this.timelineSteps[0]?.role_name;
    const prev = this.timelineSteps[index - 1]?.role_name;
    const curr = this.timelineSteps[index]?.role_name;
    return !!curr && curr !== prev;
  }
}

